import { useAuth } from "@/contexts/AuthContext";
import { useI18n } from "@/contexts/I18nContext";

export default function Login() {
  const { login } = useAuth();
  const { t } = useI18n();

  return (
    <div className="min-h-screen relative flex items-center justify-center bg-[#0B0F17] overflow-hidden" data-testid="login-view">
      <img
        src="https://static.prod-images.emergentagent.com/jobs/dc38f51e-c139-4812-b550-43302995c34d/images/2079fba5f95701e3892c1f50442f048ca9ad52940c4abc01198ebcf7a5c3372e.jpeg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover opacity-40"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F17] via-[#0B0F17]/85 to-[#0B0F17]/60" />
      <div className="relative z-10 w-full max-w-sm px-6">
        <div className="flex flex-col items-center text-center gap-3 mb-8">
          <img
            src="https://customer-assets-4nw71qhi.emergentagent.net/job_safety-protocol-hub-1/artifacts/tmh2v309_Picto%20WebApp%20Protocoles%202026.png"
            alt="Création et Gestion des protocoles"
            data-testid="login-app-picto"
            className="w-40 h-40 rounded-2xl shadow-lg shadow-black/40"
          />
          <p className="text-xs font-mono uppercase tracking-[0.15em] text-slate-500">{t("tagline")}</p>
        </div>
        <button
          onClick={login}
          data-testid="google-login-btn"
          className="w-full flex items-center justify-center gap-3 bg-white text-slate-900 font-semibold py-3 rounded-lg hover:bg-slate-100 transition-colors"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          {t("common.login_with_google")}
        </button>
      </div>
    </div>
  );
}
